import { __ } from '@wordpress/i18n'

export default {
  notFound: __('No testimonials', 'dhsv_theme'),
  buttons: {
    'Live-Demo': __('Live-Demos', 'dhsv_theme'),
    'Meet the Geek': __('Meet the Geek', 'dhsv_theme'),
    Schulung: __('Schulungen', 'dhsv_theme'),
    'Live-Schulung': __('Live-Schulungen', 'dhsv_theme'),
    'On-Demand-Schulung': __('On-Demand-Schulungen', 'dhsv_theme'),
    'On-Demand': __('On-Demand-Schulungen', 'dhsv_theme'),
    Seminar: __('Seminare', 'dhsv_theme'),
    'Online-Seminar': __('Online-Seminare', 'dhsv_theme'),
    Webinar: __('Webinare', 'dhsv_theme'),
    Workshop: __('Workshops', 'dhsv_theme'),
  },
}
